module.exports = __webpack_public_path__ + "img/water-side.a2956376.png";